import uzUZ from '../../date-picker/locale/uz_UZ';
export default uzUZ;
